export const CREATE_HOLIDAY= 'holiday@create-holiday';
export const DELETE_HOLIDAY= 'holiday@delete-holiday';
export const GET_HOLIDAY= 'holiday@get-holiday';
export const UPDATE_HOLIDAY= 'holiday@update-holiday';
